var Acr = Acr || {};

Acr.ModelSlider = function () {
  

  function setSlick(slider) {
    var showDots = slider.children().length > 1;

    slider.slick({
      autoplay: false,
      dots: showDots,
      speed: 1200,
      useTransform: true,
      nextArrow: '<svg class="acr-icon slick-next slick-arrow" '
          + 'viewBox="0 0 26 26">'
          + '<use xmlns:xlink="http://www.w3.org/1999/xlink" '
          + 'xlink:href="#arrow-right">'
          + '</use></svg>',
      prevArrow: '<svg class="acr-icon slick-prev slick-arrow" '
          + 'viewBox="0 0 26 26">'
          + '<use xmlns:xlink="http://www.w3.org/1999/xlink" '
          + 'xlink:href="#arrow-left">'
          + '</use></svg>',
    });
  }

  function init(element) {
    setSlick($(element));
  }

  return {
    init: init,
  };
};
